import { FC } from "react"
import { Dropdown } from 'react-bootstrap'
import { Button } from "../../Button/Button"



type OptionsDataTableProps = {
  options : any[]
  item:any
}

const OptionsDataTable:FC<OptionsDataTableProps> = ({
  options,
  item
})=>{
  return (
    <>
     <td className='d-flex flex-no-wrap w-25 mx-1' style={{ minWidth: '10em' }}>
                  {options
                    .filter((option) => {
                      if (!option.verifyConditionItem || !option.verifyConditionValue) {
                        return true
                      } else if (typeof option.verifyConditionValue === 'function') {
                        // Permitir uso de Funções
                        return option.verifyConditionValue(item[option.verifyConditionItem])
                      } else {
                        return (
                          item[option.verifyConditionItem] === option.verifyConditionValue
                        )
                      }
                    })
                    .map((option, index) => (
                      <div
                        className={`d-flex align-items-center me-5 ${option.icon && option.icon.includes('trash')
                          ? 'text-hover-danger'
                          : `${option.icon.includes('eye') ? '' : 'text-hover-primary'}`
                          } cursor-pointer`}
                        key={index}
                        style={{ whiteSpace: 'nowrap' }}
                      >
                        {option.dropdownItems && option.icon && (
                          <Dropdown style={{ padding: 0, margin: 0 }}>
                            <Dropdown.Toggle
                              variant='default'
                              size='sm'
                              style={{ padding: 0, margin: 0 }}
                            >
                              <i title={option.title} className={`${option.icon} fs-4`}></i>
                            </Dropdown.Toggle>
                            <Dropdown.Menu className='p-0'>
                              {option.dropdownItems.map((dropdownItem:any) => (
                                <Dropdown.Item
                                  key={dropdownItem.text}
                                  className='p-0 d-flex flex-row justify-content-center'
                                  onClick={() => dropdownItem.action(item)}
                                >
                                  <div
                                    className='btn m-4 d-flex flex-row justify-content-center align-items-center'
                                    style={{
                                      color: '#6993FF',
                                      backgroundColor: '#E1E9FF',
                                      width: '90%',
                                    }}
                                  >
                                    <p
                                      style={{ color: '#6993FF', fontSize: '1rem' }}
                                      className='m-0'
                                    >
                                      {dropdownItem.text}
                                    </p>
                                  </div>
                                </Dropdown.Item>
                              ))}
                            </Dropdown.Menu>
                          </Dropdown>
                        )}
                        {option.isButton && (
                          <Button
                            text={option.textButton ?? ''}
                            color={option.color ?? 'primary'}
                            icon={option.icon ?? ''}
                            iconColor={option.iconColor ?? ''}
                            size='small'
                            title={option.title}
                            btnAttr={{
                              type: 'button',
                            }}
                            click={() => option.action && option.action(item)}
                            btnClass='py-2 px-3'
                          />
                        )}
                        {!option.isButton &&
                          !option.dropdownItems &&
                          option.icon &&
                          !option.fieldToShow &&
                          !option.valueToShow &&
                          (option.href ? (
                            <a href={option.href.replace('id', item.id)}>
                              <i title={option.title} className={`${option.icon} fs-4`}></i>
                            </a>
                          ) : (
                            <i
                              title={option.title}
                              className={`${option.icon} fs-4`}
                              onClick={() => option.action && option.action(item)}
                            ></i>
                          ))}
                        {option.fieldToShow &&
                          option.valueToShow &&
                          item[option.fieldToShow] === option.valueToShow && (
                            <i
                              title={option.title}
                              className={`${option.icon} fs-4`}
                              onClick={() => option.action && option.action(item)}
                            ></i>
                          )}
                      </div>
                    ))}
                </td>
    </>
  )
}

export {OptionsDataTable}